import { Box, Container, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface FooterProps {
  hide?: boolean;
}

export default function Footer({ hide = false }: FooterProps) {
  const theme = useTheme(); 
  if (hide) return null;

  return (
    <Box
      component="footer"
      sx={{
        py: 1,
        px: 2,
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        zIndex: theme.zIndex.appBar,
      }}
    >
      <Container maxWidth="xl">
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          sx={{ cursor: "default" }}
        >
          Powered By{" "}
          <Typography
            component="a"
            href="https://webstrail.com/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#1976d2",
              fontWeight: 600,
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            Webstrail
          </Typography>
        </Typography>
      </Container>
    </Box>
  );
}
